// 为组件提供 install 方法，供组件对外按需引入
import TpIcon from './icon.vue'
TpIcon.install = Vue => {
  Vue.component(TpIcon.name, TpIcon)
}

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)

export default TpIcon
